import React, { Component } from 'react';
import { useHistory } from 'react-router-dom';
export const Routedispatcher = React.createContext();
export const Routedispatcherprovider = (props) => {
    let history = useHistory();
    const routedispatchercontext = (route) => {
        history.push(route);
    };

    return (
        <Routedispatcher.Provider
            value={{
                routedispatchercontext,
            }}
        >
            {props.children}
        </Routedispatcher.Provider>
    );
};
